import { Avatar, Box, Chip, Typography } from "@mui/material";
import { ReactElement } from "react";

type CardHeaderProps = {
    title: string;
    subtitle?: string;
    rightComponent?: ReactElement;
    avatarSrc?: string;
    avatarSubstitute?: string;
    chips?: {label: string, color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'}[];
};

const CardHeader = ({title, subtitle, rightComponent, avatarSrc, avatarSubstitute, chips}: CardHeaderProps) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', px: '1.5rem', minHeight: '72px', alignItems: 'center', justifyContent: 'space-between'}}>
            <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center',}}>
                {(avatarSrc || avatarSubstitute) && (<Avatar src={avatarSrc} sx={{width: '40px', height: '40px', mr: '1rem'}}>{avatarSubstitute}</Avatar>)}
                <Box>
                    <Typography variant="h2" sx={{fontWeight: 600, color: '#15161A', fontSize: '1.875rem'}}>{title}</Typography>
                    {subtitle && (<Typography variant="body2" color='#868F99'>{subtitle}</Typography>)}
                </Box>
                {chips && (<Box sx={{ml: '0.5rem', gap: '0.5rem', display: 'flex'}}>
                    {chips?.filter((item) => item).map((chip, index) => (<Chip key={index} label={chip.label} color={chip.color} component='span'/>))}
                </Box>)}
            </Box>
            {rightComponent && (<Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center',}}>
                {rightComponent}
            </Box>)}
        </Box>
    );
};

export { CardHeader };